export const COUNTRIES = [
  {
    title: 'Afghanistan',
    value: 'AF',
    titleDanish: 'Afghanistan',
    bankGroup: 'other',
  },
  {
    title: 'Albania',
    value: 'AL',
    titleDanish: 'Albanien',
    bankGroup: 'europe',
  },
  {
    title: 'Algeria',
    value: 'DZ',
    titleDanish: 'Algeriet',
    bankGroup: 'other',
  },
  {
    title: 'American Samoa',
    value: 'AS',
    titleDanish: 'Amerikansk Samoa',
    bankGroup: 'other',
  },
  {
    title: 'Andorra',
    value: 'AD',
    titleDanish: 'Andorra',
    bankGroup: 'europe',
  },
  {
    title: 'Angola',
    value: 'AO',
    titleDanish: 'Angola',
    bankGroup: 'other',
  },
  {
    title: 'Anguilla',
    value: 'AI',
    titleDanish: 'Anguilla',
    bankGroup: 'other',
  },
  {
    title: 'Argentina',
    value: 'AR',
    titleDanish: 'Argentina',
    bankGroup: 'other',
  },
  {
    title: 'Armenia',
    value: 'AM',
    titleDanish: 'Armenien',
    bankGroup: 'other',
  },
  {
    title: 'Aruba',
    value: 'AW',
    titleDanish: 'Aruba',
    bankGroup: 'other',
  },
  {
    title: 'Australia',
    value: 'AU',
    titleDanish: 'Australien',
    bankGroup: 'other',
  },
  {
    title: 'Austria',
    value: 'AT',
    titleDanish: 'Østrig',
    bankGroup: 'europe',
  },
  {
    title: 'Azerbaijan',
    value: 'AZ',
    titleDanish: 'Aserbajdsjan',
    bankGroup: 'other',
  },
  {
    title: 'Bahamas',
    value: 'BS',
    titleDanish: 'Bahamas',
    bankGroup: 'other',
  },
  {
    title: 'Bahrain',
    value: 'BH',
    titleDanish: 'Bahrain',
    bankGroup: 'other',
  },
  {
    title: 'Bangladesh',
    value: 'BD',
    titleDanish: 'Bangladesh',
    bankGroup: 'other',
  },
  {
    title: 'Barbados',
    value: 'BB',
    titleDanish: 'Barbados',
    bankGroup: 'other',
  },
  {
    title: 'Belarus',
    value: 'BY',
    titleDanish: 'Hviderusland',
    bankGroup: 'europe',
  },
  {
    title: 'Belgium',
    value: 'BE',
    titleDanish: 'Belgien',
    bankGroup: 'europe',
  },
  {
    title: 'Belize',
    value: 'BZ',
    titleDanish: 'Belize',
    bankGroup: 'other',
  },
  {
    title: 'Benin',
    value: 'BJ',
    titleDanish: 'Benin',
    bankGroup: 'other',
  },
  {
    title: 'Bermuda',
    value: 'BM',
    titleDanish: 'Bermuda',
    bankGroup: 'other',
  },
  {
    title: 'Bhutan',
    value: 'BT',
    titleDanish: 'Bhutan',
    bankGroup: 'other',
  },
  {
    title: 'Bolivia',
    value: 'BO',
    titleDanish: 'Bolivia',
    bankGroup: 'other',
  },
  {
    title: 'Bosnia and Herzegovina',
    value: 'BA',
    titleDanish: 'Bosnien-Hercegovina',
    bankGroup: 'europe',
  },
  {
    title: 'Botswana',
    value: 'BW',
    titleDanish: 'Botswana',
    bankGroup: 'other',
  },
  {
    title: 'Brazil',
    value: 'BR',
    titleDanish: 'Brasilien',
    bankGroup: 'other',
  },
  {
    title: 'British Virgin Islands',
    value: 'VG',
    titleDanish: 'De Britiske Jomfruøer',
    bankGroup: 'other',
  },
  {
    title: 'Brunei',
    value: 'BN',
    titleDanish: 'Brunei',
    bankGroup: 'other',
  },
  {
    title: 'Bulgaria',
    value: 'BG',
    titleDanish: 'Bulgarien',
    bankGroup: 'europe',
  },
  {
    title: 'Burkina Faso',
    value: 'BF',
    titleDanish: 'Burkina Faso',
    bankGroup: 'other',
  },
  {
    title: 'Burundi',
    value: 'BI',
    titleDanish: 'Burundi',
    bankGroup: 'other',
  },
  {
    title: 'Cambodia',
    value: 'KH',
    titleDanish: 'Cambodja',
    bankGroup: 'other',
  },
  {
    title: 'Cameroon',
    value: 'CM',
    titleDanish: 'Cameroun',
    bankGroup: 'other',
  },
  {
    title: 'Canada',
    value: 'CA',
    titleDanish: 'Canada',
    bankGroup: 'other',
  },
  {
    title: 'Cape Verde',
    value: 'CV',
    titleDanish: 'Kap Verde',
    bankGroup: 'other',
  },
  {
    title: 'Cayman Islands',
    value: 'KY',
    titleDanish: 'Caymanøerne',
    bankGroup: 'other',
  },
  {
    title: 'Central African Republic',
    value: 'CF',
    titleDanish: 'Den Centralafrikanske Republik',
    bankGroup: 'other',
  },
  {
    title: 'Chad',
    value: 'TD',
    titleDanish: 'Tchad',
    bankGroup: 'other',
  },
  {
    title: 'Chile',
    value: 'CL',
    titleDanish: 'Chile',
    bankGroup: 'other',
  },
  {
    title: 'China',
    value: 'CN',
    titleDanish: 'Kina',
    bankGroup: 'other',
  },
  {
    title: 'Columbia',
    value: 'CO',
    titleDanish: 'Colombia',
    bankGroup: 'other',
  },
  {
    title: 'Comoros',
    value: 'KM',
    titleDanish: 'Comorerne',
    bankGroup: 'other',
  },
  {
    title: 'Cook Islands',
    value: 'CK',
    titleDanish: 'Cookøerne',
    bankGroup: 'other',
  },
  {
    title: 'Costa Rica',
    value: 'CR',
    titleDanish: 'Costa Rica',
    bankGroup: 'other',
  },
  {
    title: 'Croatia',
    value: 'HR',
    titleDanish: 'Kroatien',
    bankGroup: 'europe',
  },
  {
    title: 'Cuba',
    value: 'CU',
    titleDanish: 'Cuba',
    bankGroup: 'other',
  },
  {
    title: 'Curacao',
    value: 'CW',
    titleDanish: 'Curaçao',
    bankGroup: 'other',
  },
  {
    title: 'Cyprus',
    value: 'CY',
    titleDanish: 'Cypern',
    bankGroup: 'europe',
  },
  {
    title: 'Czech Republic',
    value: 'CZ',
    titleDanish: 'Tjekkiet',
    bankGroup: 'europe',
  },
  {
    title: 'Democratic Republic of the Congo',
    value: 'CD',
    titleDanish: 'Den Demokratiske Republik Congo',
    bankGroup: 'other',
  },
  {
    title: 'Denmark',
    value: 'DK',
    titleDanish: 'Danmark',
    bankGroup: 'denmark',
  },
  {
    title: 'Djibouti',
    value: 'DJ',
    titleDanish: 'Djibouti',
    bankGroup: 'other',
  },
  {
    title: 'Dominica',
    value: 'DM',
    titleDanish: 'Dominica',
    bankGroup: 'other',
  },
  {
    title: 'Dominican Republic',
    value: 'DO',
    titleDanish: 'Den Dominikanske Republik',
    bankGroup: 'other',
  },
  {
    title: 'East Timor',
    value: 'TL',
    titleDanish: 'Østtimor',
    bankGroup: 'other',
  },
  {
    title: 'Ecuador',
    value: 'EC',
    titleDanish: 'Ecuador',
    bankGroup: 'other',
  },
  {
    title: 'Egypt',
    value: 'EG',
    titleDanish: 'Egypten',
    bankGroup: 'other',
  },
  {
    title: 'El Salvador',
    value: 'SV',
    titleDanish: 'El Salvador',
    bankGroup: 'other',
  },
  {
    title: 'Eritrea',
    value: 'ER',
    titleDanish: 'Eritrea',
    bankGroup: 'other',
  },
  {
    title: 'Estonia',
    value: 'EE',
    titleDanish: 'Estland',
    bankGroup: 'europe',
  },
  {
    title: 'Ethiopia',
    value: 'ET',
    titleDanish: 'Etiopien',
    bankGroup: 'other',
  },
  {
    title: 'Faroe Islands',
    value: 'FO',
    titleDanish: 'Færøerne',
    bankGroup: 'europe',
  },
  {
    title: 'Fiji',
    value: 'FJ',
    titleDanish: 'Fiji',
    bankGroup: 'other',
  },
  {
    title: 'Finland',
    value: 'FI',
    titleDanish: 'Finland',
    bankGroup: 'europe',
  },
  {
    title: 'France',
    value: 'FR',
    titleDanish: 'Frankrig',
    bankGroup: 'europe',
  },
  {
    title: 'French Polynesia',
    value: 'PF',
    titleDanish: 'Fransk Polynesien',
    bankGroup: 'other',
  },
  {
    title: 'Gabon',
    value: 'GA',
    titleDanish: 'Gabon',
    bankGroup: 'other',
  },
  {
    title: 'Gambia',
    value: 'GM',
    titleDanish: 'Gambia',
    bankGroup: 'other',
  },
  {
    title: 'Georgia',
    value: 'GE',
    titleDanish: 'Georgien',
    bankGroup: 'other',
  },
  {
    title: 'Germany',
    value: 'DE',
    titleDanish: 'Tyskland',
    bankGroup: 'europe',
  },
  {
    title: 'Ghana',
    value: 'GH',
    titleDanish: 'Ghana',
    bankGroup: 'other',
  },
  {
    title: 'Greece',
    value: 'GR',
    titleDanish: 'Grækenland',
    bankGroup: 'europe',
  },
  {
    title: 'Greenland',
    value: 'GL',
    titleDanish: 'Grønland',
    bankGroup: 'denmark',
  },
  {
    title: 'Grenada',
    value: 'GD',
    titleDanish: 'Grenada',
    bankGroup: 'other',
  },
  {
    title: 'Guam',
    value: 'GU',
    titleDanish: 'Guam',
    bankGroup: 'other',
  },
  {
    title: 'Guatemala',
    value: 'GT',
    titleDanish: 'Guatemala',
    bankGroup: 'other',
  },
  {
    title: 'Guernsey',
    value: 'GG',
    titleDanish: 'Guernsey',
    bankGroup: 'other',
  },
  {
    title: 'Guinea',
    value: 'GN',
    titleDanish: 'Guinea',
    bankGroup: 'other',
  },
  {
    title: 'Guinea-Bissau',
    value: 'GW',
    titleDanish: 'Guinea-Bissau',
    bankGroup: 'other',
  },
  {
    title: 'Guyana',
    value: 'GY',
    titleDanish: 'Guyana',
    bankGroup: 'other',
  },
  {
    title: 'Haiti',
    value: 'HT',
    titleDanish: 'Haiti',
    bankGroup: 'other',
  },
  {
    title: 'Honduras',
    value: 'HN',
    titleDanish: 'Honduras',
    bankGroup: 'other',
  },
  {
    title: 'Hong Kong',
    value: 'HK',
    titleDanish: 'Hongkong',
    bankGroup: 'other',
  },
  {
    title: 'Hungary',
    value: 'HU',
    titleDanish: 'Ungarn',
    bankGroup: 'europe',
  },
  {
    title: 'Iceland',
    value: 'IS',
    titleDanish: 'Island',
    bankGroup: 'europe',
  },
  {
    title: 'India',
    value: 'IN',
    titleDanish: 'Indien',
    bankGroup: 'other',
  },
  {
    title: 'Indonesia',
    value: 'ID',
    titleDanish: 'Indonesien',
    bankGroup: 'other',
  },
  {
    title: 'Iran',
    value: 'IR',
    titleDanish: 'Iran',
    bankGroup: 'other',
  },
  {
    title: 'Iraq',
    value: 'IQ',
    titleDanish: 'Irak',
    bankGroup: 'other',
  },
  {
    title: 'Ireland',
    value: 'IE',
    titleDanish: 'Irland',
    bankGroup: 'europe',
  },
  {
    title: 'Isle of Man',
    value: 'IM',
    titleDanish: 'Isle of Man',
    bankGroup: 'other',
  },
  {
    title: 'Israel',
    value: 'IL',
    titleDanish: 'Israel',
    bankGroup: 'other',
  },
  {
    title: 'Italy',
    value: 'IT',
    titleDanish: 'Italien',
    bankGroup: 'europe',
  },
  {
    title: 'Ivory Coast',
    value: 'CI',
    titleDanish: 'Elfenbenskysten',
    bankGroup: 'other',
  },
  {
    title: 'Jamaica',
    value: 'JM',
    titleDanish: 'Jamaica',
    bankGroup: 'other',
  },
  {
    title: 'Japan',
    value: 'JP',
    titleDanish: 'Japan',
    bankGroup: 'other',
  },
  {
    title: 'Jersey',
    value: 'JE',
    titleDanish: 'Jersey',
    bankGroup: 'other',
  },
  {
    title: 'Jordan',
    value: 'JO',
    titleDanish: 'Jordan',
    bankGroup: 'other',
  },
  {
    title: 'Kazakhstan',
    value: 'KZ',
    titleDanish: 'Kasakhstan',
    bankGroup: 'other',
  },
  {
    title: 'Kenya',
    value: 'KE',
    titleDanish: 'Kenya',
    bankGroup: 'other',
  },
  {
    title: 'Kiribati',
    value: 'KI',
    titleDanish: 'Kiribati',
    bankGroup: 'other',
  },
  {
    title: 'Kosovo',
    value: 'XK',
    titleDanish: 'Kosovo',
    bankGroup: 'europe',
  },
  {
    title: 'Kuwait',
    value: 'KW',
    titleDanish: 'Kuwait',
    bankGroup: 'other',
  },
  {
    title: 'Kyrgyzstan',
    value: 'KG',
    titleDanish: 'Kirgisistan',
    bankGroup: 'other',
  },
  {
    title: 'Laos',
    value: 'LA',
    titleDanish: 'Laos',
    bankGroup: 'other',
  },
  {
    title: 'Latvia',
    value: 'LV',
    titleDanish: 'Letland',
    bankGroup: 'europe',
  },
  {
    title: 'Lebanon',
    value: 'LB',
    titleDanish: 'Libanon',
    bankGroup: 'other',
  },
  {
    title: 'Lesotho',
    value: 'LS',
    titleDanish: 'Lesotho',
    bankGroup: 'other',
  },
  {
    title: 'Liberia',
    value: 'LR',
    titleDanish: 'Liberia',
    bankGroup: 'other',
  },
  {
    title: 'Libya',
    value: 'LY',
    titleDanish: 'Libyen',
    bankGroup: 'other',
  },
  {
    title: 'Liechtenstein',
    value: 'LI',
    titleDanish: 'Liechtenstein',
    bankGroup: 'europe',
  },
  {
    title: 'Lithuania',
    value: 'LT',
    titleDanish: 'Litauen',
    bankGroup: 'europe',
  },
  {
    title: 'Luxembourg',
    value: 'LU',
    titleDanish: 'Luxembourg',
    bankGroup: 'europe',
  },
  {
    title: 'Macau',
    value: 'MO',
    titleDanish: 'Macau',
    bankGroup: 'other',
  },
  {
    title: 'Macedonia',
    value: 'MK',
    titleDanish: 'Nordmakedonien',
    bankGroup: 'europe',
  },
  {
    title: 'Madagascar',
    value: 'MG',
    titleDanish: 'Madagaskar',
    bankGroup: 'other',
  },
  {
    title: 'Malawi',
    value: 'MW',
    titleDanish: 'Malawi',
    bankGroup: 'other',
  },
  {
    title: 'Malaysia',
    value: 'MY',
    titleDanish: 'Malaysia',
    bankGroup: 'other',
  },
  {
    title: 'Maldives',
    value: 'MV',
    titleDanish: 'Maldiverne',
    bankGroup: 'other',
  },
  {
    title: 'Mali',
    value: 'ML',
    titleDanish: 'Mali',
    bankGroup: 'other',
  },
  {
    title: 'Malta',
    value: 'MT',
    titleDanish: 'Malta',
    bankGroup: 'europe',
  },
  {
    title: 'Marshall Islands',
    value: 'MH',
    titleDanish: 'Marshalløerne',
    bankGroup: 'other',
  },
  {
    title: 'Mauritania',
    value: 'MR',
    titleDanish: 'Mauretanien',
    bankGroup: 'other',
  },
  {
    title: 'Mauritius',
    value: 'MU',
    titleDanish: 'Mauritius',
    bankGroup: 'other',
  },
  {
    title: 'Mayotte',
    value: 'YT',
    titleDanish: 'Mayotte',
    bankGroup: 'other',
  },
  {
    title: 'Mexico',
    value: 'MX',
    titleDanish: 'Mexico',
    bankGroup: 'other',
  },
  {
    title: 'Micronesia',
    value: 'FM',
    titleDanish: 'Mikronesien',
    bankGroup: 'other',
  },
  {
    title: 'Moldova',
    value: 'MD',
    titleDanish: 'Moldova',
    bankGroup: 'europe',
  },
  {
    title: 'Monaco',
    value: 'MC',
    titleDanish: 'Monaco',
    bankGroup: 'europe',
  },
  {
    title: 'Mongolia',
    value: 'MN',
    titleDanish: 'Mongoliet',
    bankGroup: 'other',
  },
  {
    title: 'Montenegro',
    value: 'ME',
    titleDanish: 'Montenegro',
    bankGroup: 'europe',
  },
  {
    title: 'Morocco',
    value: 'MA',
    titleDanish: 'Marokko',
    bankGroup: 'other',
  },
  {
    title: 'Mozambique',
    value: 'MZ',
    titleDanish: 'Mozambique',
    bankGroup: 'other',
  },
  {
    title: 'Myanmar',
    value: 'MM',
    titleDanish: 'Myanmar',
    bankGroup: 'other',
  },
  {
    title: 'Namibia',
    value: 'NA',
    titleDanish: 'Namibia',
    bankGroup: 'other',
  },
  {
    title: 'Nepal',
    value: 'NP',
    titleDanish: 'Nepal',
    bankGroup: 'other',
  },
  {
    title: 'Netherlands',
    value: 'NL',
    titleDanish: 'Holland',
    bankGroup: 'europe',
  },
  {
    title: 'New Caledonia',
    value: 'NC',
    titleDanish: 'Ny Kaledonien',
    bankGroup: 'other',
  },
  {
    title: 'New Zealand',
    value: 'NZ',
    titleDanish: 'New Zealand',
    bankGroup: 'other',
  },
  {
    title: 'Nicaragua',
    value: 'NI',
    titleDanish: 'Nicaragua',
    bankGroup: 'other',
  },
  {
    title: 'Niger',
    value: 'NE',
    titleDanish: 'Niger',
    bankGroup: 'other',
  },
  {
    title: 'Nigeria',
    value: 'NG',
    titleDanish: 'Nigeria',
    bankGroup: 'other',
  },
  {
    title: 'North Korea',
    value: 'KP',
    titleDanish: 'Nordkorea',
    bankGroup: 'other',
  },
  {
    title: 'Northern Mariana Islands',
    value: 'MP',
    titleDanish: 'Nordmarianerne',
    bankGroup: 'other',
  },
  {
    title: 'Norway',
    value: 'NO',
    titleDanish: 'Norge',
    bankGroup: 'europe',
  },
  {
    title: 'Oman',
    value: 'OM',
    titleDanish: 'Oman',
    bankGroup: 'other',
  },
  {
    title: 'Pakistan',
    value: 'PK',
    titleDanish: 'Pakistan',
    bankGroup: 'other',
  },
  {
    title: 'Palestine',
    value: 'PS',
    titleDanish: 'Palæstina',
    bankGroup: 'other',
  },
  {
    title: 'Panama',
    value: 'PA',
    titleDanish: 'Panama',
    bankGroup: 'other',
  },
  {
    title: 'Papua New Guinea',
    value: 'PG',
    titleDanish: 'Papua Ny Guinea',
    bankGroup: 'other',
  },
  {
    title: 'Paraguay',
    value: 'PY',
    titleDanish: 'Paraguay',
    bankGroup: 'other',
  },
  {
    title: 'Peru',
    value: 'PE',
    titleDanish: 'Peru',
    bankGroup: 'other',
  },
  {
    title: 'Philippines',
    value: 'PH',
    titleDanish: 'Filippinerne',
    bankGroup: 'other',
  },
  {
    title: 'Poland',
    value: 'PL',
    titleDanish: 'Polen',
    bankGroup: 'europe',
  },
  {
    title: 'Portugal',
    value: 'PT',
    titleDanish: 'Portugal',
    bankGroup: 'europe',
  },
  {
    title: 'Puerto Rico',
    value: 'PR',
    titleDanish: 'Puerto Rico',
    bankGroup: 'other',
  },
  {
    title: 'Qatar',
    value: 'QA',
    titleDanish: 'Qatar',
    bankGroup: 'other',
  },
  {
    title: 'Republic of the Congo',
    value: 'CG',
    titleDanish: 'Republikken Congo',
    bankGroup: 'other',
  },
  {
    title: 'Reuropenion',
    value: 'RE',
    titleDanish: 'Réunion',
    bankGroup: 'other',
  },
  {
    title: 'Romania',
    value: 'RO',
    titleDanish: 'Rumænien',
    bankGroup: 'europe',
  },
  {
    title: 'Russia',
    value: 'RU',
    titleDanish: 'Rusland',
    bankGroup: 'other',
  },
  {
    title: 'Rwanda',
    value: 'RW',
    titleDanish: 'Rwanda',
    bankGroup: 'other',
  },
  {
    title: 'Saint Kitts and Nevis',
    value: 'KN',
    titleDanish: 'Saint Kitts og Nevis',
    bankGroup: 'other',
  },
  {
    title: 'Saint Lucia',
    value: 'LC',
    titleDanish: 'Saint Lucia',
    bankGroup: 'other',
  },
  {
    title: 'Saint Martin',
    value: 'MF',
    titleDanish: 'Saint Martin',
    bankGroup: 'other',
  },
  {
    title: 'Saint Pierre and Miquelon',
    value: 'PM',
    titleDanish: 'Saint Pierre og Miquelon',
    bankGroup: 'other',
  },
  {
    title: 'Saint Vincent and the Grenadines',
    value: 'VC',
    titleDanish: 'Saint Vincent og Grenadinerne',
    bankGroup: 'other',
  },
  {
    title: 'Samoa',
    value: 'WS',
    titleDanish: 'Samoa',
    bankGroup: 'other',
  },
  {
    title: 'San Marino',
    value: 'SM',
    titleDanish: 'San Marino',
    bankGroup: 'europe',
  },
  {
    title: 'Sao Tome and Principe',
    value: 'ST',
    titleDanish: 'São Tomé og Príncipe',
    bankGroup: 'other',
  },
  {
    title: 'Saudi Arabia',
    value: 'SA',
    titleDanish: 'Saudi-Arabien',
    bankGroup: 'other',
  },
  {
    title: 'Senegal',
    value: 'SN',
    titleDanish: 'Senegal',
    bankGroup: 'other',
  },
  {
    title: 'Serbia',
    value: 'RS',
    titleDanish: 'Serbien',
    bankGroup: 'europe',
  },
  {
    title: 'Seychelles',
    value: 'SC',
    titleDanish: 'Seychellerne',
    bankGroup: 'other',
  },
  {
    title: 'Sierra Leone',
    value: 'SL',
    titleDanish: 'Sierra Leone',
    bankGroup: 'other',
  },
  {
    title: 'Singapore',
    value: 'SG',
    titleDanish: 'Singapore',
    bankGroup: 'other',
  },
  {
    title: 'Sint Maarten',
    value: 'SX',
    titleDanish: 'Sint Maarten',
    bankGroup: 'other',
  },
  {
    title: 'Slovakia',
    value: 'SK',
    titleDanish: 'Slovakiet',
    bankGroup: 'europe',
  },
  {
    title: 'Slovenia',
    value: 'SI',
    titleDanish: 'Slovenien',
    bankGroup: 'europe',
  },
  {
    title: 'Solomon Islands',
    value: 'SB',
    titleDanish: 'Salomonøerne',
    bankGroup: 'other',
  },
  {
    title: 'Somalia',
    value: 'SO',
    titleDanish: 'Somalia',
    bankGroup: 'other',
  },
  {
    title: 'South Africa',
    value: 'ZA',
    titleDanish: 'Sydafrika',
    bankGroup: 'other',
  },
  {
    title: 'South Korea',
    value: 'KR',
    titleDanish: 'Sydkorea',
    bankGroup: 'other',
  },
  {
    title: 'South Sudan',
    value: 'SS',
    titleDanish: 'Sydsudan',
    bankGroup: 'other',
  },
  {
    title: 'Spain',
    value: 'ES',
    titleDanish: 'Spanien',
    bankGroup: 'europe',
  },
  {
    title: 'Sri Lanka',
    value: 'LK',
    titleDanish: 'Sri Lanka',
    bankGroup: 'other',
  },
  {
    title: 'Sudan',
    value: 'SD',
    titleDanish: 'Sudan',
    bankGroup: 'other',
  },
  {
    title: 'Suriname',
    value: 'SR',
    titleDanish: 'Surinam',
    bankGroup: 'other',
  },
  {
    title: 'Swaziland',
    value: 'SZ',
    titleDanish: 'Swaziland',
    bankGroup: 'other',
  },
  {
    title: 'Sweden',
    value: 'SE',
    titleDanish: 'Sverige',
    bankGroup: 'europe',
  },
  {
    title: 'Switzerland',
    value: 'CH',
    titleDanish: 'Schweiz',
    bankGroup: 'europe',
  },
  {
    title: 'Syria',
    value: 'SY',
    titleDanish: 'Syrien',
    bankGroup: 'other',
  },
  {
    title: 'Taiwan',
    value: 'TW',
    titleDanish: 'Taiwan',
    bankGroup: 'other',
  },
  {
    title: 'Tajikistan',
    value: 'TJ',
    titleDanish: 'Tadsjikistan',
    bankGroup: 'other',
  },
  {
    title: 'Tanzania',
    value: 'TZ',
    titleDanish: 'Tanzania',
    bankGroup: 'other',
  },
  {
    title: 'Thailand',
    value: 'TH',
    titleDanish: 'Thailand',
    bankGroup: 'other',
  },
  {
    title: 'Togo',
    value: 'TG',
    titleDanish: 'Togo',
    bankGroup: 'other',
  },
  {
    title: 'Tonga',
    value: 'TO',
    titleDanish: 'Tonga',
    bankGroup: 'other',
  },
  {
    title: 'Trinidad and Tobago',
    value: 'TT',
    titleDanish: 'Trinidad og Tobago',
    bankGroup: 'other',
  },
  {
    title: 'Tunisia',
    value: 'TN',
    titleDanish: 'Tunesien',
    bankGroup: 'other',
  },
  {
    title: 'Turkey',
    value: 'TR',
    titleDanish: 'Tyrkiet',
    bankGroup: 'other',
  },
  {
    title: 'Turkmenistan',
    value: 'TM',
    titleDanish: 'Turkmenistan',
    bankGroup: 'other',
  },
  {
    title: 'Turks and Caicos Islands',
    value: 'TC',
    titleDanish: 'Turks- og Caicosøerne',
    bankGroup: 'other',
  },
  {
    title: 'Tuvalu',
    value: 'TV',
    titleDanish: 'Tuvalu',
    bankGroup: 'other',
  },
  {
    title: 'U.S. Virgin Islands',
    value: 'VI',
    titleDanish: 'De Amerikanske Jomfruøer',
    bankGroup: 'other',
  },
  {
    title: 'Uganda',
    value: 'UG',
    titleDanish: 'Uganda',
    bankGroup: 'other',
  },
  {
    title: 'Ukraine',
    value: 'UA',
    titleDanish: 'Ukraine',
    bankGroup: 'europe',
  },
  {
    title: 'United Arab Emirates',
    value: 'AE',
    titleDanish: 'De Forenede Arabiske Emirater',
    bankGroup: 'other',
  },
  {
    title: 'United Kingdom',
    value: 'GB',
    titleDanish: 'Storbritannien',
    bankGroup: 'europe',
  },
  {
    title: 'United States',
    value: 'US',
    titleDanish: 'USA',
    bankGroup: 'usa',
  },
  {
    title: 'Uruguay',
    value: 'UY',
    titleDanish: 'Uruguay',
    bankGroup: 'other',
  },
  {
    title: 'Uzbekistan',
    value: 'UZ',
    titleDanish: 'Usbekistan',
    bankGroup: 'other',
  },
  {
    title: 'Vanuatu',
    value: 'VU',
    titleDanish: 'Vanuatu',
    bankGroup: 'other',
  },
  {
    title: 'Venezuela',
    value: 'VE',
    titleDanish: 'Venezuela',
    bankGroup: 'other',
  },
  {
    title: 'Vietnam',
    value: 'VN',
    titleDanish: 'Vietnam',
    bankGroup: 'other',
  },
  {
    title: 'Western Sahara',
    value: 'EH',
    titleDanish: 'Vestsahara',
    bankGroup: 'other',
  },
  {
    title: 'Yemen',
    value: 'YE',
    titleDanish: 'Yemen',
    bankGroup: 'other',
  },
  {
    title: 'Zambia',
    value: 'ZM',
    titleDanish: 'Zambia',
    bankGroup: 'other',
  },
  {
    title: 'Zimbabwe',
    value: 'ZW',
    titleDanish: 'Zimbabwe',
    bankGroup: 'other',
  },
] as const;

export type Country = (typeof COUNTRIES)[number];
export type CountryCode = (typeof COUNTRIES)[number]['value'];
export type BankGroup = Country['bankGroup'];

export const COUNTRY_CODES = COUNTRIES.map(country => country.value);

export const getCountryBankGroup = (countryCode: CountryCode): BankGroup => {
  const normalizedCountryCode = countryCode?.trim().toUpperCase() ?? '';

  return COUNTRIES.find(country => country.value === normalizedCountryCode)?.bankGroup ?? 'other';
};
